import { render } from "./TeamMembersSlider.vue?vue&type=template&id=4730c923"
import script from "./TeamMembersSlider.vue?vue&type=script&lang=js"
export * from "./TeamMembersSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__